export default __webpack_public_path__ + "static/media/twitter.414e874e.png";